import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { isIP } from "validator";
import { networkKeys } from "../../samples/queryKeys";
import { DomainReport } from "../@types";
import api from "../api";
import { USEQUERY_DISABLE_REFETCH_OPTIONS } from "../consts";

const { cloud_enabled: cloudEnabled } = window.tcbase.consts;

export const defaultDomainReportQueryOptions = (
  domain: string | undefined
) => ({
  queryKey: networkKeys.domainReport(domain),
  queryFn: () => api.domainReport({ domain: domain || "" }),
  select: ({ data }: AxiosResponse<DomainReport>) => data,
  enabled: Boolean(cloudEnabled && domain && !isIP(domain)),
  retryOnMount: false,
  ...USEQUERY_DISABLE_REFETCH_OPTIONS
});
const useNetworkThreatIntelDomainReport = (domain: string | undefined) => {
  const {
    data: domainReport,
    isLoading,
    isFetching,
    isSuccess,
    error,
    refetch
  } = useQuery({
    ...defaultDomainReportQueryOptions(domain)
  });
  return {
    data: domainReport,
    isLoading,
    isFetching,
    isSuccess,
    error,
    refetch
  };
};

export default useNetworkThreatIntelDomainReport;
